// Ubicación en el repo: src/components/TransferStockModal.jsx
// "Traspasar stock" — Fase B del módulo de Inventario (migración 0049,
// 25-ago-2026): mueve mercadería entre dos sucursales, con registro en
// `stock_transfers`. La sucursal de origen viene fija (la que está activa
// arriba en la barra, `fromBranchId`) — para traspasar "al revés" basta
// cambiar de sucursal activa y volver a abrir este modal. El traspaso en sí
// es atómico del lado del servidor (`transfer_stock`, SECURITY DEFINER):
// si algo falla a mitad de camino, no queda stock "perdido".
import { useEffect, useState } from 'react';
import { listBranchStock, transferStock } from '../lib/catalog';

export default function TransferStockModal({ item, fromBranchId, branches, onClose, onSaved }) {
  const [branchStock, setBranchStock] = useState([]);
  const [loadingStock, setLoadingStock] = useState(true);
  const [toBranchId, setToBranchId] = useState('');
  const [quantity, setQuantity] = useState('1');
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    listBranchStock(item.id)
      .then(setBranchStock)
      .catch(() => setBranchStock([]))
      .finally(() => setLoadingStock(false));
  }, [item.id]);

  const fromBranchName = branches.find((b) => b.id === fromBranchId)?.name || 'esta sucursal';
  const destinationOptions = branches.filter((b) => b.id !== fromBranchId);
  const currentStock = branchStock.find((s) => s.branch_id === fromBranchId)?.stock ?? item.stock ?? 0;

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    if (!toBranchId) {
      setError('Elige la sucursal de destino.');
      return;
    }
    const qty = Number(quantity);
    if (!qty || qty <= 0) {
      setError('La cantidad debe ser mayor a cero.');
      return;
    }
    if (qty > currentStock) {
      setError(`Solo hay ${currentStock} unidades disponibles en ${fromBranchName}.`);
      return;
    }
    setSaving(true);
    try {
      await transferStock({
        catalogId: item.id,
        fromBranchId,
        toBranchId,
        quantity: qty,
        note: note.trim(),
      });
      onSaved();
    } catch (err) {
      setError(err.message || 'No se pudo traspasar el stock.');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h2>
          Traspasar stock · {item.brand} {item.model}
        </h2>
        <p className="field-hint" style={{ marginTop: -6 }}>
          Desde <strong>{fromBranchName}</strong> (
          {loadingStock ? 'cargando…' : `${currentStock} disponibles`}) hacia otra sucursal.
        </p>

        {!loadingStock && branchStock.length > 0 && (
          <ul className="field-hint" style={{ marginTop: -4, marginBottom: 12 }}>
            {branchStock.map((s) => (
              <li key={s.branch_id}>
                {s.branches?.name || '—'}: {s.stock} unidades
              </li>
            ))}
          </ul>
        )}

        <form onSubmit={handleSubmit} className="patient-form">
          <label className="field">
            <span>Sucursal de destino *</span>
            <select value={toBranchId} onChange={(e) => setToBranchId(e.target.value)}>
              <option value="">—</option>
              {destinationOptions.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.name}
                </option>
              ))}
            </select>
          </label>
          <label className="field">
            <span>Cantidad *</span>
            <input
              type="number"
              min="1"
              max={currentStock || undefined}
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
          </label>
          <label className="field">
            <span>Nota</span>
            <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Opcional" />
          </label>

          {error && <p className="auth-error">{error}</p>}

          <div className="modal-actions">
            <button type="button" className="button-secondary" onClick={onClose} disabled={saving}>
              Cancelar
            </button>
            <button type="submit" className="button-primary" disabled={saving || loadingStock}>
              {saving ? 'Traspasando…' : 'Traspasar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
